import { render, staticRenderFns } from "./SchoolList.vue?vue&type=template&id=4e1fa56b&scoped=true&"
import script from "./SchoolList.vue?vue&type=script&lang=ts&"
export * from "./SchoolList.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolList.vue?vue&type=style&index=0&id=4e1fa56b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1fa56b",
  null
  
)

export default component.exports